import { Group } from './FractionIllustrated.type'

export const MIN_NUMERATORS = [1, 1, 1, 1]
export const MAX_NUMERATORS = [3, 3, 5, 7]
export const MIN_DENOMINATORS = [1, 1, 1, 5]
export const MAX_DENOMINATORS = [4, 4, 6, 8]
export const MAX_HISTORY_LENGTH = [2, 2, 3, 4]
export const MAX_GROUP_HISTORY_LENGTH = 2
export const IS_PIECES_TOGETHER = [1, 1, 1, 0]
export const GROUPS: Group[] = [
  {
    nameKey: 'bootcamp:fractions.illustrated.group.marbles',
    items: [
      {
        nameKey: 'bootcamp:fractions.illustrated.item.redMarbles',
        srcKey: 'bootcamp/fraction-illustrations/red-marble.png',
      },
      {
        nameKey: 'bootcamp:fractions.illustrated.item.blueMarbles',
        srcKey: 'bootcamp/fraction-illustrations/blue-marble.png',
      },
    ],
  },
  {
    nameKey: 'bootcamp:fractions.illustrated.group.balls',
    items: [
      {
        nameKey: 'bootcamp:fractions.illustrated.item.basketballs',
        srcKey: 'bootcamp/fraction-illustrations/basketball.png',
      },
      {
        nameKey: 'bootcamp:fractions.illustrated.item.footballs',
        srcKey: 'bootcamp/fraction-illustrations/football.png',
      },
    ],
  },
  {
    nameKey: 'bootcamp:fractions.illustrated.group.cubes',
    items: [
      {
        nameKey: 'bootcamp:fractions.illustrated.item.redCubes',
        srcKey: 'bootcamp/fraction-illustrations/red-cube.png',
      },
      {
        nameKey: 'bootcamp:fractions.illustrated.item.blueCubes',
        srcKey: 'bootcamp/fraction-illustrations/blue-cube.png',
      },
    ],
  },
  {
    nameKey: 'bootcamp:fractions.illustrated.group.animal',
    items: [
      {
        nameKey: 'bootcamp:fractions.illustrated.item.dogs',
        srcKey: 'bootcamp/fraction-illustrations/dog.png',
      },
      {
        nameKey: 'bootcamp:fractions.illustrated.item.cats',
        srcKey: 'bootcamp/fraction-illustrations/cat.png',
      },
    ],
  },
  {
    nameKey: 'bootcamp:fractions.illustrated.group.houses',
    items: [
      {
        nameKey: 'bootcamp:fractions.illustrated.item.redHouses',
        srcKey: 'bootcamp/fraction-illustrations/red-house.png',
      },
      {
        nameKey: 'bootcamp:fractions.illustrated.item.blueHouses',
        srcKey: 'bootcamp/fraction-illustrations/blue-house.png',
      },
    ],
  },
]
